import React from "react";
import BudgetManagerComponent from "../BudgetManager";
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function BudgetManager(props) {
    return (
    <>
      <Helmet>
        <title>Student Budget Manager & Expense Tracker | Student Tools Hub</title>
        <meta name="description" content="Free budget manager designed for students. Track expenses, manage your money, and stay financially organized throughout your academic journey." />
        <meta name="keywords" content="student budget, expense tracker, money manager, college budget, financial planner" />

        <meta property="og:title" content="Free Student Budget Manager & Expense Tracker" />
        <meta property="og:description" content="Free budget manager designed for students. Track expenses, manage your money, and stay financially organized." />
        <meta property="og:url" content="https://student-tools-hub.vercel.app/budget" />
      </Helmet>

        <BudgetManagerComponent {...props} />;
    </>
    );
}

